export default "__VITE_ASSET__B$jxukIY__"